// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';
import { UsersRoutingModule } from './users-routing.module';

// Custom packages - Components
import { AddUserComponent } from 'src/app/modules/users/pages/add-user/add-user.page';
import { TaggerListComponent } from 'src/app/modules/users/pages/tagger-list/tagger-list.page';
import { UserDetailComponent } from 'src/app/modules/users/pages/user-detail/user-detail.page';
import { UsersListComponent } from 'src/app/modules/users/pages/users-list/users-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    UsersRoutingModule,
    PublicModule,
  ],
  declarations: [
    UsersListComponent,
    UserDetailComponent,
    AddUserComponent,
    TaggerListComponent,
  ],
  exports: [
  ]
})
export class UsersModule { }
